import React from 'react';
import propTypes from 'prop-types';

export function NewModelCard(props) {
  const { block } = props;

  return (
    <div
      className={`${block} ${block}--new-model dark-theme bg-black ${props.modifierClass}`}
      style={{
        backgroundImage: `linear-gradient(180deg, ${props.backgroundColor} 40%, transparent 60%), url("${props.backgroundImg}"`
      }}
    >
      {props.heading}
      {props.buttons}
    </div>
  );
};

NewModelCard.propTypes = {
  modifierClass: propTypes.string,
  modelName: propTypes.string.isRequired,
  description: propTypes.string.isRequired,
  backgroundImage: propTypes.string,
  backgroundColor: propTypes.string,
  buttonOneText: propTypes.string,
  buttonOneOnClickCallback: propTypes.func,
  buttonTwoText: propTypes.string,
  heading: propTypes.element.isRequired,
  buttons: propTypes.element
};
